import { useTranslation } from 'next-i18next'

function useHelpCenterLabels() {
    const { t } = useTranslation('helpcenter')

    return {
        help: {
            readMore: t('articleLabels.readMore'),
            feedbacks: {
                title: t('articleLabels.feedback.title'),
                textLogin: t('articleLabels.feedback.textLogin'),
                login: t('articleLabels.feedback.login'),
                yes: t('articleLabels.feedback.yes'),
                no: t('articleLabels.feedback.no'),
                improveTitle: t('articleLabels.feedback.improveTitle'),
                improvePlaceholder: t('articleLabels.feedback.improvePlaceholder'),
                send: t('articleLabels.feedback.send'),
                thanks: t('articleLabels.feedback.thanks'),
                cancel: t('articleLabels.feedback.cancel'),
            },
            articleBoxes: {
                quickTip: t('articleLabels.articleBoxes.quickTip'),
                note: t('articleLabels.articleBoxes.note'),
                warning: t('articleLabels.articleBoxes.warning'),
            },
        },
        platforms: {
            select: t('articleLabels.platforms.select'),
            web: t('articleLabels.platforms.web'),
            ios: t('articleLabels.platforms.ios'),
            android: t('articleLabels.platforms.android'),
            mac: t('articleLabels.platforms.mac'),
            'windows-legacy': t('articleLabels.platforms.windowsLegacy'),
            'windows-10': t('articleLabels.platforms.windows10'),
            linux: t('articleLabels.platforms.linux'),
        },
    }
}

export { useHelpCenterLabels }
